<template>
  <ul class="payment-form-usps">
    <li
      v-for="(usp, index) in usps"
      :key="index"
      class="payment-form-usps__item"
    >
      <svg viewBox="0 0 512 512" class="payment-form-usps__item-icon">
        <use href="#circle-check" />
      </svg>
      <span class="payment-form-usps__item-text" v-html="usp" />
    </li>
  </ul>
</template>

<script lang="ts">
export default {
  name: 'PaymentFormUsps',

  props: {
    onlyShowFirst: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      texts: window.theme_vars.paymentFormUsps,
    };
  },

  computed: {
    usps() {
      if (this.onlyShowFirst) {
        return [this.texts.usp1];
      }

      return [this.texts.usp1, this.texts.usp2];
    },
  },
};
</script>
